var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"pl-3 dashboard-views-utilities-area",attrs:{"cols":"3"}},[_c('dashboard-module-base-area',{attrs:{"area":_vm.state.zone.area,"options":_vm.state.zone.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }